import { computed } from 'vue'

import type { ComputedRef } from 'vue'
import type { SelectSearchOption } from '@shared/ui/fields'
import type { KanbanAgent } from '@entities/task'

import { useTutorKanbanStore } from './store'

interface TutorKanbanSelectAgentReturn {
  refOptions: ComputedRef<SelectSearchOption<number | null>[]>
  refCurrent: ComputedRef<SelectSearchOption<number | null> | null>
  handleChange: (option: SelectSearchOption<string | number | null>) => void
}

const INITIAL_OPTION: SelectSearchOption<number | null> = {
  id: 0,
  value: null,
  text: '--- Not selected ---',
  selected: true,
}

export const useTutorKanbanSelectAgent = (): TutorKanbanSelectAgentReturn => {
  const tutorKanbanStore = useTutorKanbanStore()

  const refOptions = computed<SelectSearchOption<number | null>[]>(() => {
    const currentAgentId = tutorKanbanStore.getTutor?.agent?.id ?? null

    const options: SelectSearchOption<number | null>[] = tutorKanbanStore.getAgents.map((agent: KanbanAgent) => ({
      id: agent.id,
      value: agent.id,
      text: agent.name,
      selected: currentAgentId !== null && agent.id === currentAgentId,
    }))

    return [INITIAL_OPTION, ...options]
  })

  const refCurrent = computed<SelectSearchOption<number | null> | null>(() => {
    const currentAgentId = tutorKanbanStore.getTutor?.agent?.id ?? null
    return refOptions.value.find(option => option.value === currentAgentId) ?? null
  })

  const handleChange = (option: SelectSearchOption<string | number | null>): void => {
    const agentId = option.value ? Number(option.value) : null
    const agent = agentId
      ? tutorKanbanStore.getAgents.find((a: KanbanAgent) => a.id === agentId) ?? null
      : null

    tutorKanbanStore.setTutorAgent(agent)
  }

  return {
    refOptions,
    refCurrent,
    handleChange,
  }
}
